(function () {
  'use strict';

  var SELLING_PLAN_NAME = 'selling_plan';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var format =
        (window.theme && window.theme.moneyFormat) ||
        window.Shopify.money_format ||
        '${{amount}}';
      return window.Shopify.formatMoney(cents, format);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function buildAtcHtml(label, priceCents, compareCents) {
    var compareHtml =
      compareCents && Number(compareCents) > Number(priceCents)
        ? '<span class="atc-price-compare strike-through">' +
          formatMoney(compareCents) +
          '</span>'
        : '';
    return (
      '<span class="atc-btn-layout">' +
      '<span class="atc-btn-label">' +
      label +
      '</span>' +
      '<span class="atc-btn-sep" aria-hidden="true"><svg width="1" height="27" viewBox="0 0 1 27" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="0.5" y1="2.18557e-08" x2="0.499999" y2="27" stroke="currentColor"/></svg></span>' +
      '<span class="atc-price-current">' +
      formatMoney(priceCents) +
      '</span>' +
      compareHtml +
      '</span>'
    );
  }

  function formContains(form, node) {
    return form === node || (typeof form.contains === 'function' && form.contains(node));
  }

  function getSection(root) {
    return root.closest('.buy-button-purchase-type-form-section');
  }

  function getProductForm(section) {
    if (!section) return null;
    var formId = section.dataset.productFormId;
    if (formId) {
      var byId = document.getElementById(formId);
      if (byId) return byId;
    }
    return section.querySelector('product-form-component form.shopify-product-form');
  }

  function getAllSellingPlanInputs(productForm, section) {
    var inputs = [];
    if (productForm) {
      inputs = Array.from(
        productForm.querySelectorAll('[data-purchase-selling-plan], [name="' + SELLING_PLAN_NAME + '"]')
      );
    }
    if (section && section.dataset.sellingPlanInputId) {
      var byId = document.getElementById(section.dataset.sellingPlanInputId);
      if (byId && inputs.indexOf(byId) === -1) inputs.push(byId);
    }
    return inputs;
  }

  function isOneTimePurchase(input) {
    if (!input) return false;
    if (input.id === 'purchase-option-onetime') return true;
    if (input.closest('.purchase-options__card--onetime')) return true;
    return String(input.value).trim() === 'One-Time';
  }

  function getQuantityForPlan(input) {
    if (!input || isOneTimePurchase(input)) return 1;
    var planName = input.getAttribute('data-plan-name') || '';
    if (planName === '1-month') return 1;
    if (planName === '3-month') return 3;
    if (planName === '6-month') return 6;
    var months = parseInt(input.getAttribute('data-plan-months') || '1', 10);
    return months > 0 ? months : 1;
  }

  function getSellingPlanId(input) {
    if (!input || isOneTimePurchase(input)) return '';
    return (
      input.getAttribute('data-selling-plan-id') ||
      input.getAttribute('value') ||
      ''
    );
  }

  function setSellingPlanInputsState(inputs, isOneTime, planId) {
    inputs.forEach(function (input) {
      if (isOneTime) {
        input.value = '';
        input.disabled = true;
        if (input.getAttribute('name') === SELLING_PLAN_NAME) {
          input.dataset.purchaseOptionsSavedName = SELLING_PLAN_NAME;
          input.removeAttribute('name');
        }
      } else {
        input.disabled = false;
        if (!input.getAttribute('name') && input.dataset.purchaseOptionsSavedName) {
          input.setAttribute('name', input.dataset.purchaseOptionsSavedName);
        }
        if (!input.getAttribute('name')) {
          input.setAttribute('name', SELLING_PLAN_NAME);
        }
        input.value = planId;
      }
    });
  }

  function syncCardSelection(section, input) {
    if (!section) return;
    section.querySelectorAll('.purchase-options__card').forEach(function (card) {
      card.classList.remove('is-selected');
    });
    var card = input.closest('.purchase-options__card');
    if (card) card.classList.add('is-selected');
  }

  function getCheckedOption(section) {
    var checked = section.querySelector('input[name="purchase_type_option"]:checked');
    if (checked) return checked;
    var selectedCard = section.querySelector('.purchase-options__card.is-selected');
    if (selectedCard) {
      return selectedCard.querySelector('input[name="purchase_type_option"]');
    }
    return null;
  }

  function syncPurchaseOption(section, input) {
    if (!section || !input) return false;

    var productForm = getProductForm(section);
    if (!productForm) return false;

    var sellingPlanInputs = getAllSellingPlanInputs(productForm, section);
    var quantityInput = productForm.querySelector('[name="quantity"]');
    var buyBlock = section.querySelector('.buy-buttons-block');
    var atcContent = section.querySelector('.add-to-cart-text__content');

    var isOneTime = isOneTimePurchase(input);
    var planId = getSellingPlanId(input);
    var quantity = getQuantityForPlan(input);
    var monthlyCents = parseInt(input.getAttribute('data-monthly-cents') || '0', 10);
    var compareCents = parseInt(input.getAttribute('data-compare-cents') || '0', 10);
    var totalCents = monthlyCents * quantity;
    var totalCompareCents = compareCents * quantity;

    section.dataset.purchaseType = isOneTime ? 'onetime' : 'subscription';

    if (buyBlock) {
      buyBlock.classList.toggle('enable_subscribe_option', !isOneTime);
    }

    setSellingPlanInputsState(sellingPlanInputs, isOneTime, planId);

    if (quantityInput) {
      quantityInput.value = String(quantity);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (atcContent) {
      var label = (atcContent.getAttribute('data-atc-label') || 'ADD TO CART').toUpperCase();
      var atcCompareCents = totalCompareCents;
      if (isOneTime && (!atcCompareCents || atcCompareCents <= totalCents)) {
        atcCompareCents = 0;
      }
      if (!isOneTime && atcCompareCents <= totalCents) {
        atcCompareCents = 0;
      }
      atcContent.innerHTML = buildAtcHtml(label, totalCents, atcCompareCents);
    }

    syncCardSelection(section, input);

    if (typeof window.syncStickyBarPrice === 'function') {
      window.syncStickyBarPrice();
    }
    if (typeof window.syncStickyBarSubtitle === 'function') {
      window.syncStickyBarSubtitle();
    }

    return true;
  }

  function stripSellingPlanFromFormData(formData) {
    if (!formData || typeof formData.delete !== 'function') return;
    formData.delete(SELLING_PLAN_NAME);
    formData.delete('selling_plan[]');
  }

  function isCartAddRequest(url) {
    if (!url) return false;
    return String(url).indexOf('/cart/add') !== -1;
  }

  function patchCartAddFetch() {
    if (window.__purchaseOptionsFetchPatched) return;
    window.__purchaseOptionsFetchPatched = true;

    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      if (isCartAddRequest(url) && init && init.body instanceof FormData) {
        document.querySelectorAll('.buy-button-purchase-type-form-section').forEach(function (section) {
          if (section.dataset.purchaseType === 'onetime') {
            stripSellingPlanFromFormData(init.body);
            return;
          }
          if (!section.dataset.productFormId) return;
          var checked = getCheckedOption(section);
          if (checked && isOneTimePurchase(checked)) {
            stripSellingPlanFromFormData(init.body);
          }
        });
      }
      return originalFetch.apply(this, arguments);
    };
  }

  function ensureOnetimeFormState(section) {
    if (!section || section.dataset.purchaseType !== 'onetime') return;

    var productForm = getProductForm(section);
    if (!productForm) return;

    var sellingPlanInputs = getAllSellingPlanInputs(productForm, section);
    var quantityInput = productForm.querySelector('[name="quantity"]');

    setSellingPlanInputsState(sellingPlanInputs, true, '');
    section.dataset.purchaseType = 'onetime';

    if (quantityInput) {
      quantityInput.value = '1';
    }
  }

  function bindOnetimeSection(section) {
    if (!section || section.dataset.purchaseOnetimeBound === 'true') return;
    if (section.dataset.purchaseType !== 'onetime') return;

    section.dataset.purchaseOnetimeBound = 'true';
    ensureOnetimeFormState(section);

    var productForm = getProductForm(section);
    if (productForm) {
      productForm.addEventListener(
        'submit',
        function () {
          ensureOnetimeFormState(section);
        },
        true
      );
    }
  }

  function bindSection(section) {
    if (!section || section.dataset.purchaseOptionsBound === 'true') return;
    section.dataset.purchaseOptionsBound = 'true';

    var picker = section.querySelector('[data-purchase-options]');
    if (!picker) return;

    function handleSelection(input) {
      if (!input || input.name !== 'purchase_type_option') return;
      input.checked = true;
      syncPurchaseOption(section, input);
      if (typeof input.blur === 'function') {
        input.blur();
      }
    }

    picker.addEventListener('change', function (event) {
      var target = event.target;
      if (target && target.name === 'purchase_type_option') {
        handleSelection(target);
      }
    });

    picker.addEventListener('click', function (event) {
      var card = event.target.closest('.purchase-options__card');
      if (!card) return;
      var input = card.querySelector('input[name="purchase_type_option"]');
      if (input) handleSelection(input);
    });

    var checked = getCheckedOption(section);
    if (checked) syncPurchaseOption(section, checked);
  }

  function initAll() {
    patchCartAddFetch();
    document.querySelectorAll('.buy-button-purchase-type-form-section').forEach(function (section) {
      if (section.querySelector('[data-purchase-options]')) {
        bindSection(section);
      } else if (section.dataset.purchaseType === 'onetime') {
        bindOnetimeSection(section);
      }
    });
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.classList.contains('shopify-product-form')) return;

      var section = form.closest('.buy-button-purchase-type-form-section');
      if (!section) return;

      if (section.dataset.purchaseType === 'onetime') {
        ensureOnetimeFormState(section);
        return;
      }

      if (!section.querySelector('[data-purchase-options]')) return;

      var checked = getCheckedOption(section);
      if (checked) syncPurchaseOption(section, checked);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
